const ProductListingWidgetUX = () => {
    if ($('.section-product-listing-widget').length <= 0) return null;
    
    $('.section-product-listing-widget').each(function() {
        
        const $parent = $(this);
        const $lmoreBtn = $parent.find('.load-more-btn');

        const $container = $parent.find('.product-list');
        const $prevArrow = $parent.find('.custom-slider-arrow.prev');
        const $nextArrow = $parent.find('.custom-slider-arrow.next');
        const $artifactToggles = $parent.find('.artifact-toggle');
        
        const $ctaButtons = $parent.find('.product-detail .primary-btn');

        const slickOptions = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: true,
            prevArrow: $prevArrow,
            nextArrow: $nextArrow
        }

        $lmoreBtn.click(function() {
            $parent.find('.plw-column.hidden:lt(4)').removeClass('hidden');
            if ($parent.find('.plw-column.hidden').length <= 0) {
                $(this).fadeOut();
            }
        })

        //mobile initialize slider
        if ($(window).width() < 641) {
            //remove hidden items first
            $parent.find('.plw-column.hidden').removeClass('hidden');
            $container.slick(slickOptions);
        }
        

        $artifactToggles.click(function() {
            $(this).toggleClass('active');
            $(this).closest('.col-inner').find('.artifact-details').stop().fadeToggle();
        })
        
        $ctaButtons.on('mouseenter', function() {
            const $theBtn = $(this); 
            $theBtn.find('.btn-text').css('display', 'none');
            $theBtn.find('.product-price').css('display', 'block');
        }).on('mouseleave', function() {
            const $theBtn = $(this); 
            $theBtn.find('.product-price').css('display', 'none');
            $theBtn.find('.btn-text').css('display', 'block');
        })
    })
}

export default ProductListingWidgetUX;